'use client'

import { useState, useEffect, useCallback } from 'react'
import { useSSEEvent } from '@/components/providers/sse-provider'
import { getProjects, type Project } from '@/app/actions/projects'
import { ProjectCard } from './project-card'
import { AddProjectDialog } from './add-project-dialog'
import { Spinner } from '@/components/ui/spinner'

export function ProjectList() {
    const [projects, setProjects] = useState<Project[]>([])
    const [isLoading, setIsLoading] = useState(true)

    const fetchProjects = useCallback(async () => {
        const data = await getProjects()
        setProjects(data)
        setIsLoading(false)
    }, [])

    useEffect(() => {
        fetchProjects()
    }, [fetchProjects])

    // Listen for project updates - refetch on changes
    useSSEEvent('project_update', () => {
        fetchProjects()
    }, [fetchProjects])

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-full">
                <Spinner />
            </div>
        )
    }

    return (
        <div className="max-w-4xl mx-auto space-y-4">
            <div className="flex justify-end">
                <AddProjectDialog />
            </div>
            {projects.length === 0 ? (
                <div className="flex flex-col items-center justify-center p-8 border rounded-lg border-dashed">
                    <p className="text-muted-foreground">No projects connected yet.</p>
                </div>
            ) : (
                <div className="grid gap-4">
                    {projects.map((project) => (
                        <ProjectCard key={project.name} project={project} />
                    ))}
                </div>
            )}
        </div>
    )
}
